<form [formGroup]="patternForm" (ngSubmit)="onSubmit()" class="create-pattern-form">
    @if (isProcessing) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <div class="form-section">
        <h3 class="section-title">Pattern Details</h3>
        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Pattern Name</mat-label>
                <input matInput formControlName="name" placeholder="e.g., Entry Sequence">
                @if (patternForm.get('name')?.hasError('required')) {
                <mat-error>Name is required</mat-error>
                }
            </mat-form-field>
        </div>
        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description"
                    placeholder="Describe the pattern's purpose"></textarea>
            </mat-form-field>
        </div>

        <!-- Zone Configuration -->
        <div class="form-row-two">
            <mat-form-field appearance="fill" class="half-width">
                <mat-label>Target Zone</mat-label>
                <mat-select formControlName="targetZoneId" [disabled]="isLoadingZones()">
                    <mat-option value="">🌍 Outside Parking Space</mat-option>
                    @for ( zone of availableZones(); track zone.id) {
                    <mat-option [value]="zone.id">
                        {{ zone.name }}
                    </mat-option>
                    }
                </mat-select>
                <mat-hint>Where the vehicle is going (blank = outside)</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="fill" class="half-width">
                <mat-label>Source Zone</mat-label>
                <mat-select formControlName="sourceZoneId" [disabled]="isLoadingZones()">
                    <mat-option value="">🌍 Outside Parking Space</mat-option>
                    @for ( zone of availableZones(); track zone.id) {
                    <mat-option [value]="zone.id">
                        {{ zone.name }}
                    </mat-option>
                    }
                </mat-select>
                <mat-hint>Where the vehicle is coming from (blank = outside)</mat-hint>
            </mat-form-field>
        </div>

        <div class="form-row-two">
            <mat-form-field appearance="fill" class="half-width">
                <mat-label>Action</mat-label>
                <mat-select formControlName="action">
                    @for ( action of sequenceActions; track action) {
                    <mat-option [value]="action">
                        {{ action }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="half-width">
                <mat-label>Max Duration (seconds)</mat-label>
                <input matInput type="number" formControlName="maxSequenceDurationSeconds" placeholder="300">
                @if (patternForm.get('maxSequenceDurationSeconds')?.hasError('min')) {
                <mat-error>
                    Must be greater than 0
                </mat-error>
                }
            </mat-form-field>
        </div>

        <div class="form-row-two">
            <mat-form-field appearance="fill" class="half-width">
                <mat-label>Priority</mat-label>
                <input matInput type="number" formControlName="priority" placeholder="1">
                @if (patternForm.get('priority')?.hasError('min')) {
                <mat-error>
                    Priority cannot be negative
                </mat-error>
                }
            </mat-form-field>

            <div class="half-width checkbox-container">
                <mat-checkbox formControlName="isActive">
                    Pattern is Active
                </mat-checkbox>
            </div>
        </div>
    </div>

    <div class="form-section">
        <h3 class="section-title">Sequence Steps</h3>
        <div formArrayName="steps">
            @for ( step of steps.controls; track $index) {
            <div [formGroupName]="$index" class="step-container">
                <h4>Step {{ $index + 1 }}</h4>

                <div class="step-row">
                    <mat-form-field appearance="fill" class="step-order">
                        <mat-label>Order</mat-label>
                        <input matInput type="number" formControlName="stepOrder" readonly>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="step-point">
                        <mat-label>Detection Point</mat-label>
                        <mat-select formControlName="detectionPointId">
                            @for ( point of detectionPoints; track point.id) {
                            <mat-option [value]="point.id">
                                {{ point.name }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <button mat-icon-button color="warn" (click)="removeStep($index)" title="Remove Step">
                        <mat-icon>remove_circle</mat-icon>
                    </button>
                </div>

                <div class="step-row">
                    <mat-form-field appearance="fill" class="step-field">
                        <mat-label>Expected Direction</mat-label>
                        <mat-select formControlName="expectedDirection">
                            @for ( direction of pointDirections; track direction) {
                            <mat-option [value]="direction">
                                {{ direction }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="step-field">
                        <mat-label>Plate Position</mat-label>
                        <mat-select formControlName="platePosition">
                            @for ( position of platePositions; track position) {
                            <mat-option [value]="position">
                                {{ position }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <div class="step-field checkbox-container">
                        <mat-checkbox formControlName="isRequired">
                            Step is Required
                        </mat-checkbox>
                    </div>
                </div>
            </div>
            }
        </div>
        <button mat-stroked-button type="button" (click)="addStep()" class="add-step-btn">
            <mat-icon>add</mat-icon>
            Add Step
        </button>
    </div>

    <div class="form-actions">
        <button mat-stroked-button (click)="onCancel()" type="button" [disabled]="isProcessing">
            Cancel
        </button>
        <button mat-raised-button color="primary" type="submit" [disabled]="isProcessing || !patternForm.valid">
            {{ isProcessing ? 'Creating...' : 'Create Pattern' }}
        </button>
    </div>
</form>